module.exports = __webpack_public_path__ + "static/media/galerija_2023 (5).2a1f595a.png";